<rt-assistant-list-card [linkTarget]="linkTarget()" [label]="data().template">
  <div class="rows">
    <span class="template">{{ data().template }}</span>
    <span class="candidate">
      <rt-icon class="hourglass" name="timer-sand" />
      <rt-avatar
        class="avatar"
        type="initials"
        size="small-x"
        context="candidate"
        [fullName]="data().candidate.name"
        [initials]="data().candidate.initials ?? undefined"
        [imageSrc]="data().candidate.avatarUrl ?? null"
        [isColorized]="true"
      />
      <span class="name">{{ data().candidate.name }}</span>
    </span>
    @if (data().scope; as scope) {
      @switch (scope.kind) {
        @case ('job') {
          <span class="scope">
            <span [class]="['status-dot', 'status-dot--' + scope.status]"></span>
            <span class="job-title">{{ scope.title }}</span>
          </span>
        }
        @case ('multi-jobs') {
          <span class="scope multi">{{
            'tlc.tellent_assistant.list_item.in_jobs_count' | translate: { count: scope.count }
          }}</span>
        }
      }
    }
  </div>
</rt-assistant-list-card>
